import { styled } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';

export const Root = styled(Box)({
    '& .head': {
        marginBottom: '17px',
    },
    '& .subtitle': {
        color: '#9B9B9B',
        fontSize: '12px',
    },
    '& .title': {
        color: '#005E96',
        fontSize: '16px',
    },
    '& .crtTitle': {
        color: '#005E96',
        fontSize: '16px',
        fontWeight: 'bold',
    },
    '& .infoBody': {
        padding: '0 50px',
    },
    '& .invoiceWapper': {
        width: '100%',
        padding: '24px',
        backgroundColor: '#fff',
        '& .pageTitle': {
            fontSize: '16px',
            fontWeight: 'bold',
            color: '#005E96',
        },
        '& .line': {
            width: '100%',
            height: '1px',
            backgroundColor: '#F3F3F3',
            margin: '20px 0',
        },
        '& .foot': {
            margin: '10px 0',
            '& .btn': {
                marginRight: '20px',
            },
        },
        '& .textTitle': {
            fontWeight: 'bold',
            marginRight: '19px',
        },
        '& .textWapper1': {
            marginBottom: '40px',
        },
        '& .textWapper2': {
            marginBottom: '60px',
            marginLeft: '12px',
        },
        '& .textField': {
            width: '250px',
            height: '40px',
        },
        '& .w600': {
            width: '600px',
        },
    },
});